import { withStyles } from '@material-ui/core';
import Label from './common/Label';
import Detail from './common/Detail';

const styles = () => ({
  detailsContainer: {
    marginTop: 8,
    '&>div:last-child': {
      marginTop: 8
    }
  },
  container: {
    margin: '16px 0px'
  }
});
const ShrinkWrap = ({ classes, isShrinkWrap, palletCount, tallyCount }) => {
  const parsedTallyCount = Number(tallyCount);
  return (
    <div className={classes.container}>
      <Label labelText="SHRINK WRAP INTACT" />
      <div className={classes.detailsContainer}>
        <Detail
          label="Is the Pro shrink wrapped?"
          value={isShrinkWrap ? 'Yes' : 'No'}
          isFullWidth
        />
        {isShrinkWrap && (
          <Detail
            label="Number of shrink wrap intact accepted pallets"
            value={palletCount}
            isFullWidth
          />
        )}
        {isShrinkWrap && (parsedTallyCount > 0) && (
          <Detail
            label="Tally Count"
            value={parsedTallyCount}
            isFullWidth
          />
        )}
      </div>
    </div>
  );
};

export default withStyles(styles)(ShrinkWrap);
